export default {
    TOKEN_NAME: 'EVENTSTORMING_TOKEN',//token名称

    //WEB_URL: "http://localhost:8083",
    WEB_URL: process.env.VUE_APP_WEB,

    SignUp: "/sign-up", //注册
    SignIn: "/sign-in", //登录
    SendEmail: "/send-email", //邮件
    ChangePass: "/change-pass", //修改密码

    DataListSave: "/dataListSave",
    DataListUpdate: "/dataListUpdate",
    DataListInvite: "/dataListInvite",
    DataList: "/dataList",
    DataListOpen: "/dataListOpen",
    DataListSetOpen: "/DataListSetOpen",
    DataListRemoveInvite: "/dataListRemoveInvite",

    ItemList: "/itemList",
    ItemListOpen: "/itemListOpen",


}
